import SupportService from '../../service/SupportService';

// Single entry point the whole Support section fetches categories/subcategories/items
// through.
export const getSupportCategories = (userType = 'MEMBER') => {
  return SupportService.getSupportCategories(userType);
};

// Case creation/update/lookup are real, backend-deployed mutations/query (see
// SupportService.js) -- unlike getSupportCategories above, these do NOT fall back to a mock
// on failure, since silently faking a "success" for a case filing would mislead the member
// into thinking their request was actually submitted.
export const createMemberSupportCase = (input, xUser) => SupportService.createMemberSupportCase(input, xUser);

export const updateMemberSupportCase = (id, input) => SupportService.updateMemberSupportCase(id, input);

export const getMemberSupportCase = (id) => SupportService.getMemberSupportCase(id);

export const getMemberSupportCases = (variables) => SupportService.getMemberSupportCases(variables);

// Confirmed deployed 2026-10-01 -- a member's response to one of their own OPEN infoRequests
// (AdditionalInfoRequest, §11a). input: { body, infoRequestId, documents: [{ documentType,
// fileName, storageUri, description }] }.
export const submitMemberSupportCaseInfo = (caseId, input) => SupportService.submitMemberSupportCaseInfo(caseId, input);
